import {
  REPORT_CUSTOMER_REPORT_FAILURE,
  REPORT_CUSTOMER_REPORT_REQUEST,
  REPORT_CUSTOMER_REPORT_SEARCH_FAILURE,
  REPORT_CUSTOMER_REPORT_SEARCH_REQUEST,
  REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS,
  REPORT_CUSTOMER_REPORT_SUCCESS,
} from "./CustomerReportTypes";

// Customer Report Actions
export const customerReportRequest = (pageNo) => ({
  type: REPORT_CUSTOMER_REPORT_REQUEST,
  payload: pageNo,
});

export const customerReportSuccess = (report) => ({
  type: REPORT_CUSTOMER_REPORT_SUCCESS,
  payload: report,
});

export const customerReportFailure = (error) => ({
  type: REPORT_CUSTOMER_REPORT_FAILURE,
  payload: error,
});

//Customer Search
export const customerReportSearchRequest = (queryObj) => ({
  type: REPORT_CUSTOMER_REPORT_SEARCH_REQUEST,
  payload: queryObj,
});

export const customerReportSearchSuccess = (results) => ({
  type: REPORT_CUSTOMER_REPORT_SEARCH_SUCCESS,
  payload: results,
});

export const customerReportSearchFailure = (error) => ({
  type: REPORT_CUSTOMER_REPORT_SEARCH_FAILURE,
  payload: error,
});
